import log from 'loglevel';
import { IPathToPageIdMap } from '@move-frontend/contentful-routes';
import { getUrlForPage } from '../navigation/getUrlForPage';
import { IMenuItemNavBar } from '../contentful/types/IMenuItemNavBar';
import { IMenuItemEntry } from '../contentful/types/IMenuItem';
import { ISiteSectionEntry } from '../contentful/types/ISiteSection';

export const adaptSiteSectionsToSubMenuItem = (
	items: ISiteSectionEntry[],
	pathToPageIdMap: IPathToPageIdMap,
): IMenuItemNavBar[] =>
	items
		.map((item: ISiteSectionEntry) => {
			if (item.fields.hideFromTopNavigation) {
				return undefined;
			}
			const matchedPage = getUrlForPage(
				pathToPageIdMap,
				item.fields.landingPage?.fields?.id,
			);
			if (!matchedPage) {
				log.warn('Unmatched menu item');
				return undefined;
			}
			return {
				id: item.fields.id,
				title: item.fields.title,
				url: matchedPage ?? '',
			};
		})
		.filter((item) => !!item);

export const adaptSubMenuItems = (
	pathToPageIdMap: IPathToPageIdMap,
	items?: IMenuItemEntry[],
): IMenuItemNavBar[] =>
	items
		?.map((item: IMenuItemEntry) => {
			const matchedPage = getUrlForPage(
				pathToPageIdMap,
				item.fields.page?.fields?.id,
			);

			if (!matchedPage) {
				log.warn('Unmatched menu item');
				return undefined;
			}

			return {
				id: item.id,
				title: item.fields.title,
				url: matchedPage,
			};
		})
		.filter((menuItem) => !!menuItem) || [];
